export const snackMessage = {
    fieldErrors: (errorFields) => `These fields has error(s): ${Object.keys(errorFields).join(" ,")}`,
    addTodoSuccess: "Todo Added Successfully!",
    updateTodoSuccess: "Todo Updated Successfully!",
    deleteTodoSuccess: "Todo Deleted Successfully!",
    toggleTodoSuccess: (status) => `Marked Todo as ${status ? "completed" : "not completed"}!`,
    subscriptionCancelledSuccess: `Subscription Cancelled Successfully!`,
    subscriptionCancelledFailed: `Something went wrong. Please try again.`
}